export default __webpack_public_path__ + "assets/images/limu-219e7059bd9ebd70731216b2d694527b.png";